import { render, staticRenderFns } from "./ColumnValidation.vue?vue&type=template&id=f5cb87ea&scoped=true&"
import script from "./ColumnValidation.vue?vue&type=script&lang=ts&"
export * from "./ColumnValidation.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnValidation.vue?vue&type=style&index=0&id=f5cb87ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb87ea",
  null
  
)

export default component.exports